import { AbacoWebModule, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import globals from "./globals";

export default class ChartsModule implements AbacoWebModule {
    public static MODULE_ID = "dashboard_charts_module";

    private httpClient!: HTTPClient;

    readonly id = ChartsModule.MODULE_ID;
    readonly globalComponents = globals;

    public get http(): HTTPClient {
        return this.httpClient;
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.httpClient = evt.http;
    }

}
